module.exports = __webpack_public_path__ + "static/media/xcalibra_black_on_green.b9155ba6.png";